/** This browser changed a report; the navbar alerts re-read it. The open dashboard already has the change. */
export const REPORTS_CHANGED_EVENT = "reports-changed";

/** A push arrived: another user changed something, so everything on screen that shows reports re-reads them. */
export const REPORTS_STALE_EVENT = "reports-stale";

/** Calls the handler when the person comes back to the page; returning fires both `focus` and `visibilitychange`, so it runs once */
export const whenPageShown = (handler: () => void) => {
  let last = 0;
  const run = () => {
    if (document.visibilityState === "hidden") return;
    const now = Date.now();
    if (now - last < 1000) return;
    last = now;
    handler();
  };
  window.addEventListener("focus", run);
  document.addEventListener("visibilitychange", run);
  return () => {
    window.removeEventListener("focus", run);
    document.removeEventListener("visibilitychange", run);
  };
};
